import { Instagram, Facebook } from "lucide-react";
import WordMark from "@/components/WordMark";
import { scrollToId } from "@/lib/scroll";

const QUICK_LINKS = [
  { label: "Services", href: "#expertise" },
  { label: "About", href: "#facility" },
  { label: "Book Service", href: "#contact" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink pb-44 pt-24 md:pb-16">
      <div className="mx-auto flex max-w-7xl flex-col items-center px-6 text-center sm:px-10">
        <WordMark small />
        <p className="mt-6 text-[11px] font-semibold uppercase tracking-[0.35em] text-ivory/40">
          Part of V-Elite Autoverse
        </p>
        <p className="mt-3 text-sm font-light text-ivory/60">
          Premium Automotive Care. Redefined.
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {QUICK_LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => scrollToId(l.href)}
              className="text-[11px] font-semibold uppercase tracking-[0.25em] text-ivory/50 transition-colors duration-300 hover:text-gold"
            >
              {l.label}
            </button>
          ))}
        </div>

        <a
          href="tel:+919688996889"
          data-testid="footer-phone"
          className="gold-text mt-8 font-display text-xl font-bold tracking-[0.15em]"
        >
          96889 96889
        </a>
        <p className="mt-2 text-[11px] uppercase tracking-[0.3em] text-ivory/40">Tirupur</p>
        <p className="mt-2 max-w-xs text-[10px] font-light leading-relaxed text-ivory/35">
          295/2, Sundamedu, Vidyalayam, Karuppa Gaundanpalayam, Tiruppur 641605
        </p>

        <div className="mt-8 flex items-center gap-4">
          <a
            href="https://www.instagram.com/v_elite.drives/"
            target="_blank"
            rel="noreferrer"
            aria-label="V-Elite Drives on Instagram"
            data-testid="footer-instagram-link"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/25 text-ivory/70 transition-colors duration-300 hover:border-gold/60 hover:text-gold"
          >
            <Instagram size={17} strokeWidth={1.5} />
          </a>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noreferrer"
            aria-label="V-Elite Drives on Facebook"
            data-testid="footer-facebook-link"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/25 text-ivory/70 transition-colors duration-300 hover:border-gold/60 hover:text-gold"
          >
            <Facebook size={17} strokeWidth={1.5} />
          </a>
        </div>

        <div className="mt-12 w-full border-t border-gold/10 pt-6 text-[10px] uppercase tracking-[0.25em] text-ivory/25">
          © 2026 V-Elite Drives · Tirupur, Tamil Nadu
        </div>
      </div>
    </footer>
  );
}
